import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import { RevisePubProjectProposalViewList } from 'features/RevisePubProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function RevisePubProjectProposalViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="project_proposal">
            <RevisePubProjectProposalViewList />
          </Can>
          <Can not do="read" on="project_proposal">
            <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default RevisePubProjectProposalViewListPage;
